const PD_LINK_DRAWER_TRIGGER_LABEL = 'products.glasses.prescription.form.pdDrawerTrigger';

export { PD_LINK_DRAWER_TRIGGER_LABEL };
//# sourceMappingURL=types.js.map
